import { useCallback, useEffect, useState } from 'react';

export const useUrlPredictionInfo = (urlPredictionIdArg?: string, urlPredictionTypeArg?: string) => {
  const [urlPredictionId, setUrlPredictionId] = useState<string | undefined>(urlPredictionIdArg);
  const [urlPredictionType, setUrlPredictionType] = useState<string | undefined>(urlPredictionTypeArg);

  useEffect(() => {
    setUrlPredictionId(urlPredictionIdArg);
    setUrlPredictionType(urlPredictionTypeArg);
  }, [urlPredictionIdArg, urlPredictionTypeArg]);

  const resetUrlData = useCallback(() => {
    setUrlPredictionId(undefined);
    setUrlPredictionType(undefined);
  }, []);

  return {
    urlPredictionId,
    urlPredictionType,
    resetUrlData
  };
};
